module.exports = __webpack_public_path__ + "static/media/sand-clock.6b7a76aa.png";